var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffHighResolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 9.09091,
    fill: "#CAD3C0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18155_455531",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 9.09091,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18155_455531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8035 27.7734C30.0366 27.7736 37.4695 35.1103 37.4695 44.2236V45.9551H4.13647V44.2236C4.13649 35.1102 11.5701 27.7734 20.8035 27.7734ZM20.4998 7.77344C24.8511 7.77344 28.3787 11.301 28.3787 15.6523C28.3786 20.0036 24.8511 23.5312 20.4998 23.5312C16.1486 23.5311 12.6209 20.0035 12.6208 15.6523C12.6208 11.3011 16.1486 7.77363 20.4998 7.77344Z",
    fill: "#E0EAD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffHighResolution);
export default __webpack_public_path__ + "static/media/staff_high_resolution.46a4c72d13f43461488f88519c82a73d.svg";
export { ForwardRef as ReactComponent };